import { useCallback } from 'preact/hooks';

import { useAppState } from '../stores/app-store/app-store';
import { useWs } from './use-ws';
import { MessageAction, MessageType } from './use-ws/types';

interface ObfuscatedEvent {
  type: string;
  name: string;
  properties: {
    blink: number;
    kcv: number;
    user_id: number | undefined;
  };
}

const generateRandomString = (length: number = 5): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join('');
};

const calculateDateSum = (date: Date): number => {
  return date
    .getFullYear()
    .toString()
    .concat(
      (date.getMonth() + 1).toString().padStart(2, '0'),
      date.getDate().toString().padStart(2, '0')
    )
    .split('')
    .reduce((sum, digit) => sum + parseInt(digit), 0);
};

export const useObfuscatedAdEvents = () => {
  const { sendMessage } = useWs();
  const { userProfile, game } = useAppState();

  const sendObfuscatedEvents = useCallback(() => {
    const now = Date.now();
    const userId = userProfile?.telegramId;

    const events: ObfuscatedEvent[] = [
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: now - 60000,
          kcv: Math.floor(Math.random() * 10),
          user_id: userId,
        },
      },
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: now + 60000,
          kcv: Math.floor(Math.random() * 10),
          user_id: userId,
        },
      },
      {
        type: generateRandomString(),
        name: generateRandomString(),
        properties: {
          blink: new Date().setUTCHours(0, 0, 0, 0),
          kcv: calculateDateSum(new Date()),
          user_id: userId,
        },
      },
    ].sort(() => Math.random() - 0.5);

    events.forEach((event) => {
      sendMessage(MessageType.ANALYTICS, MessageAction.EXECUTE, {
        type: event.type,
        user_properties: {
          telegram_id: userId,
        },
        event_properties: {
          name: event.name,
          blink: event.properties.blink,
          kcv: event.properties.kcv,
          game_key: game?.key ?? 0,
        },
      });
    });
  }, [sendMessage, userProfile?.telegramId, game?.key]);

  return { sendObfuscatedEvents };
};
